<template>
  <div>
    <create-doctor
      fetchClinicsBy="franchise" />
  </div>
</template>

<script>

import createDoctor from '../../components/doctors/createDoctor.vue';

export default {
  components: {
      createDoctor,
  },
  data:()=>({
  }),
};
</script>
